import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addAOPlatformToLayout } from "./addAOPlatformToLayout";
import { addAOChartToLayout } from "./addAOChartToLayout";
import { addAOCreatorsToLayout } from "./addAOCreatorsToLayout";

export const addAudienceOverlapToLayout = (
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.audienceOverlap;

  Object.keys(campaigns).forEach((campaignId) => {
    const { audienceOverlap } = campaigns[campaignId];

    if (!audienceOverlap) return;
    const { audienceOverlapData } = audienceOverlap;

    if (
      (aggregation && campaignId !== "aggregated") ||
      (!aggregation && campaignId === "aggregated")
    )
      return;

    if (
      !aggregation &&
      campaignId !== "aggregated" &&
      Object.keys(campaigns).length > 1
    ) {
      addHeaderToLayout(`audience-overlap-${campaignId}`, newLayout, format, 3);
    }

    const overlapProviders = Object.keys(audienceOverlapData || {});

    overlapProviders.forEach((provider) => {
      const overlapData = audienceOverlapData[provider];

      if (!overlapData?.audienceOverlap?.data) return;

      addAOPlatformToLayout(newLayout, format, campaignId, provider);
      addAOChartToLayout(newLayout, format, campaignId, provider);
      addAOCreatorsToLayout(
        newLayout,
        format,
        campaignId,
        provider,
        overlapData,
      );
    });
  });
};
